import { render } from "./Welcome.vue?vue&type=template&id=e733c444&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=e733c444&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e733c444"]])

export default __exports__